export default "__VITE_ASSET__DbuV3$_i__"